<div class="default_progress-bar" *ngIf="isFetching"></div>
<nz-layout>
  <app-layout-header></app-layout-header>
  <nz-layout class="layout_context">

    <nz-sider class="sider_menu" [nzCollapsible]="true" [nzCollapsedWidth]="this.settings.layout.collapsedWidth"
      [(nzCollapsed)]="settings.layout.collapsed" [nzTrigger]="null">
      <div nz-dropdown [nzDropdownMenu]="menu" nzTrigger="click" class="menu_user_dropdown">
        <nz-avatar [nzSrc]="settings.user.avatar|src"></nz-avatar>
        <div *ngIf="!settings.layout.collapsed" class="menu_user_dropdown_title">
          <strong>{{settings.user.name}}</strong>
          <p class="menu_user_dropdown_title_email">{{settings.user.email}}</p>
        </div>
      </div>
      <ul class="menu_ul" nz-menu nzMode="inline" (nzClick)="onMenuItemClick()">
        <ng-container *ngFor="let item of settings.menu.items; index as i">
          <li *ngIf="item.type==1 else submenu" nz-menu-item nz-tooltip [nzMatchRouter]="true">
            <a routerLink="{{item.routerLink}}">
              <i nz-icon [nzType]="item.icon"></i>
              <span>{{item.title|translate}}</span>
            </a>
          </li>
          <ng-template #submenu>
            <li nz-submenu [nzTitle]="item.title|translate" [nzIcon]="item.icon" [nzOpen]="i==0?true:false">
              <ul>
                <li *ngFor="let item of item.submenu" [nzMatchRouter]="true" nz-menu-item><a
                    routerLink="{{item.routerLink}}" title="{{item.title|translate}}">{{item.title|translate}}</a></li>
              </ul>
            </li>
          </ng-template>
        </ng-container>
      </ul>
      <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul nz-menu nzSelectable>
          <li nz-menu-item [nzMatchRouter]="true" [routerLink]="'/account/center'"><i nz-icon
              nzType="user"></i>{{'menu.account'|translate}}</li>
          <li nz-menu-item [nzMatchRouter]="true" [routerLink]="'/account/settings'"><i nz-icon
              nzType="setting"></i>{{'menu.account.settings'|translate}}</li>
        </ul>
      </nz-dropdown-menu>

    </nz-sider>
    <nz-layout class="layout_context right-layout">
      <nz-content>
        <div class="inner-content">
          <router-outlet></router-outlet>
        </div>
      </nz-content>
    </nz-layout>
    <div class="messageContext" [ngClass]="{'message-context-opened':settings.messageBox.show}" nz-resizable
      (nzResize)="onResize($event)" [nzMinWidth]="810" [nzMinHeight]="556" nzBounds="window"
      [style.top]="settings.messageBox.top" [style.left]="settings.messageBox.left"
      [style.right]="settings.messageBox.right" [style.bottom]="settings.messageBox.bottom"
      [style.width]="settings.messageBox.width" [style.height]="settings.messageBox.height">
      <nz-resize-handle nzDirection="bottomRight">
        <i class="bottom-right" nz-icon nzType="caret-up" nzTheme="outline" [nzRotate]="135"></i>
      </nz-resize-handle>
      <nz-resize-handle nzDirection="right">
      </nz-resize-handle>
      <!-- *ngIf="settings.isMobile"-->
      <app-im (onChange)="onImChange($event)"></app-im>
      <!-- <app-im-moblie *ngIf="settings.isMobile" (onChange)="onImChange($event)"></app-im-moblie> -->

    </div>
    <!--*ngIf="settings.liveInfo.Show"-->
    <div class="live" *ngIf="settings.liveInfo.Show" [ngStyle]="{'width':!settings.liveInfo.IsCreator?'100%':'auto'}">
      <app-live-room></app-live-room>
    </div>
    <div class="im" (click)="toggle()" style="display: none;">
      <i nz-icon nzType="message" class="message-drawer__handle-icon"></i>
    </div>

  </nz-layout>
</nz-layout>